<template>
  <!--  -->
  <div class="button-wrapper">
    <!--  -->
    <button
      v-if="!link && !div"
      :disabled="disabled"
      class="btn inline-flex justify-center"
      :class="[
        loading ? 'pointer-events-none' : '',
        disabled ? 'opacity-40 cursor-not-allowed' : '',
        btnClass,
      ]"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <!--  -->
      <template v-if="!loading && !$slots.default">
        <!--  -->
        <span class="flex items-center">
          <!--  -->
          <span
            v-if="icon"
            :class="[
              iconPosition === 'right' ? 'order-1 ml-2' : '',
              text && iconPosition === 'left' ? 'mr-2' : '',
              iconClass,
            ]"
          >
            <!--  -->
            <Icon :icon="icon" />
            <!--  -->
          </span>
          <!--  -->

          <!--  -->
          <span v-if="text">{{ text }}</span>
          <!--  -->
        </span>
        <!--  -->
      </template>
      <!--  -->

      <!--  -->
      <template v-if="loading">
        <!--  -->
        <svg
          class="animate-spin -ml-1 mr-3 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          :class="loadingClass"
        >
          <!--  -->
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <!--  -->

          <!--  -->
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
          <!--  -->
        </svg>
        <!--  -->
        {{ loadingText }}
      </template>
      <!--  -->

      <!--  -->
      <div v-if="$slots.default && !loading">
        <!--  -->
        <slot></slot>
        <!--  -->
      </div>
      <!--  -->
    </button>
    <!--  -->

    <!--  -->
    <router-link
      v-else-if="link && !div"
      :to="link"
      class="btn inline-flex justify-center"
      :class="[
        loading ? 'pointer-events-none' : '',
        disabled ? 'opacity-40 cursor-not-allowed' : '',
        btnClass,
      ]"
      v-on="$listeners"
    >
      <!--  -->
      <template v-if="!loading && !$slots.default">
        <!--  -->
        <span class="flex items-center">
          <!--  -->
          <span
            v-if="icon"
            :class="[
              iconPosition === 'right' ? 'order-1 ml-2' : '',
              text && iconPosition === 'left' ? 'mr-2' : '',
              iconClass,
            ]"
          >
            <!--  -->
            <Icon :icon="icon" />
            <!--  -->
          </span>
          <!--  -->

          <!--  -->
          <span v-if="text">{{ text }}</span>
          <!--  -->
        </span>
        <!--  -->
      </template>
      <!--  -->

      <!--  -->
      <template v-if="loading">
        <!--  -->
        <svg
          class="animate-spin -ml-1 mr-3 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          :class="loadingClass"
        >
          <!--  -->
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <!--  -->

          <!--  -->
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
          <!--  -->
        </svg>
        <!--  -->
        {{ loadingText }}
        <!--  -->
      </template>
      <!--  -->

      <!--  -->
      <div v-if="$slots.default && !loading">
        <!--  -->
        <slot></slot>
        <!--  -->
      </div>
      <!--  -->
    </router-link>
    <!--  -->

    <!--  -->
    <div
      v-else
      class="btn inline-flex justify-center"
      :class="[
        loading ? 'pointer-events-none' : '',
        disabled ? 'opacity-40 cursor-not-allowed' : '',
        btnClass,
      ]"
      v-on="$listeners"
    >
      <!--  -->
      <template v-if="!loading && !$slots.default">
        <!--  -->
        <span class="flex items-center">
          <!--  -->
          <span
            v-if="icon"
            :class="[
              iconPosition === 'right' ? 'order-1 ml-2' : '',
              text && iconPosition === 'left' ? 'mr-2' : '',
              iconClass,
            ]"
          >
            <!--  -->
            <Icon :icon="icon" />
            <!--  -->
          </span>
          <!--  -->

          <!--  -->
          <span v-if="text">{{ text }}</span>
          <!--  -->
        </span>
        <!--  -->
      </template>
      <!--  -->

      <!--  -->
      <template v-if="loading">
        <!--  -->
        <svg
          class="animate-spin -ml-1 mr-3 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          :class="loadingClass"
        >
          <!--  -->
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <!--  -->

          <!--  -->
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
          <!--  -->
        </svg>
        <!--  -->
        {{ loadingText }}
        <!--  -->
      </template>
      <!--  -->

      <!--  -->
      <div v-if="$slots.default && !loading">
        <!--  -->
        <slot></slot>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import Icon from "@/components/Icon";

export default {
  name: "Button",
  components: {
    Icon,
  },
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "Loading ...",
    },
    btnClass: {
      type: String,
      default: "bg-primary text-white",
    },
    icon: {
      type: String,
      default: "",
    },
    iconPosition: {
      type: String,
      default: "left",
    },
    iconClass: {
      type: String,
      default: "text-[20px]",
    },
    loadingClass: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    div: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
